import Layout from "../../components/Layout";

export function Page({ }) {
  //const images = [image1, image2];
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1>
            Технические решения для Добывающей промышленности
          </h1>
          <p>
            Современные тенденции и пути развития систем автоматизации технологических процессов в российской добывающей промышленности связаны с цифровизацией, повышением эффективности добычи, снижением затрат и улучшением экологических показателей.
          </p>
          <p>
            SCADA-системы играют ключевую роль в современных тенденциях автоматизации добывающей промышленности России. Они обеспечивают сбор данных, мониторинг и управление процессами в реальном времени. Компании добывающей промышленности в России активно внедряют SCADA-системы для модернизации своих производственных процессов и повышения конкурентоспособности на мировом рынке.
          </p>
          <p>
            Рассмотрим примеры решения по автоматизации с применением <b>SCADA NPT Compact</b>:
          </p>

          <ul className="mb-4 description__list">
            <li className="mb-1 description__number-li"  >
              <b>Цифровизация и создание цифровых двойников</b>
              <ul>
                <li><b>Тенденция:</b> Внедрение цифровых технологий для моделирования и оптимизации процессов добычи, включая создание цифровых двойников месторождений и оборудования.</li>
                <li><b>Применение SCADA Compact:</b>SCADA NPT Compact собирают данные с датчиков и оборудования, которые используются для создания и обновления цифровых двойников. Это позволяет моделировать различные сценарии работы и оптимизировать процессы.</li>

              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Автоматизация процессов добычи</b>
              <ul>
                <li><b>Тенденция:</b> Внедрение автоматизированных систем для управления процессами бурения, добычи и транспортировки полезных ископаемых.</li>
                <li>
                  <b>Применение SCADA Compact:</b> SCADA NPT Compact может обеспечивать контроль за работой оборудования, таких как насосы, компрессоры и буровые установки, в режиме реального времени. Она также позволяет автоматически регулировать параметры работы для повышения эффективности работы оборудования.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Интеграция IoT и промышленного интернета вещей (IIoT)</b>
              <ul>
                <li><b>Тенденция:</b> Использование IoT-устройств для сбора данных и управления оборудованием.</li>
                <li><b>Применение SCADA Compact:</b>SCADA NPT Compact может интегрироваться с IoT-устройствами, такими как датчики давления, температуры и вибрации, для мониторинга состояния оборудования и предотвращения аварий.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Прогнозирующее техническое обслуживание (Predictive Maintenance)</b>
              <ul>
                <li><b>Тенденция:</b> Переход от планового обслуживания к обслуживанию по состоянию оборудования.</li>
                <li>
                  <b>Применение SCADA Compact:</b> SCADA NPT Compact может собирать данные о работе оборудования, которые анализируются для прогнозирования износа и планирования ремонтов.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Повышение энергоэффективности</b>
              <ul>
                <li><b>Тенденция:</b>Оптимизация энергопотребления на объектах добычи.</li>
                <li><b>Применение SCADA Compact:</b>SCADA NPT Compact позволяет контролировать энергопотребление оборудования и автоматически регулировать его работу для снижения затрат на энергию.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Экологический мониторинг и снижение выбросов</b>
              <ul>
                <li><b>Тенденция:</b>Внедрение систем мониторинга окружающей среды для снижения экологического воздействия.</li>
                <li><b>Применение SCADA Compact:</b>SCADA NPT Compact может интегрироваться с датчиками контроля выбросов и качества воздуха, что позволяет оперативно выявлять и устранять нарушения.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Автоматизация транспортировки и логистики</b>
              <ul>
                <li><b>Тенденция:</b> Внедрение автоматизированных систем для управления транспортировкой нефти, газа и других полезных ископаемых.</li>
                <li>
                  <b>Применение SCADA Compact:</b>SCADA NPT Compact может обеспечить контроль за работой трубопроводов, насосных станций и терминалов, что позволяет минимизировать потери и повысить безопасность.
                </li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Кибербезопасность</b>
              <ul>
                <li> <b>Тенденция:</b> Усиление защиты автоматизированных систем от кибератак.</li>
                <li> <b>Применение SCADA Compact:</b>SCADA NPT Compact оснащается встроенными средствами кибербезопасности.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Использование больших данных и искусственного интеллекта (ИИ)</b>
              <ul>
                <li> <b>Тенденция:</b> Анализ больших объемов данных для оптимизации процессов добычи и принятия решений.</li>
                <li> <b>Применение SCADA Compact:</b>SCADA NPT Compact может собрать данные, которые затем анализируются для прогнозирования добычи, оптимизации режимов работы и снижения затрат.</li>
              </ul>
            </li>
            <li className="mb-1 description__number-li"  >
              <b>Развитие облачных технологий</b>
              <ul>
                <li> <b>Тенденция:</b>Использование облачных платформ для хранения и обработки данных.</li>
                <li> <b>Применение SCADA Compact:</b> SCADA NPT Compact может интегрироваться с облачными платформами и MES системами, что позволяет централизованно управлять данными и активами.</li>
              </ul>
            </li>
          </ul>



        </div>
      </div>
    </Layout>
  );
}
export const meta = {
  title: 'Технические решения для Добывающей промышленности',
  description: 'SCADA-системы играют ключевую роль в современных тенденциях автоматизации добывающей промышленности России. Они обеспечивают сбор данных, мониторинг и управление процессами в реальном времени.'
}
//export const doNotPrerender = false;